import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const oneYearOldEquipment: BlogMetaData = {
  title: 'モンテッソーリ教育の1歳向け知育おもちゃ６選｜選び方も解説',
  description:
    '１歳ごろのお子様におすすめのモンテッソーリ教具を紹介！子どもの興味に基づいた教具の選び方とおすすめ教具をモンテ歴２０年の講師が紹介します',
  thumbnailUrl: '/img/blog-1-year-old-equipment.webp',
  filePath: buildBlogFilePath('1-years-old-equipment'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
